export default "__VITE_ASSET__CoFkfscn__"